import type { User } from "../../models/User";
import type { WPContentBlock } from "../../models/WPContentBlock";
import type { WPPageDescriptor } from "../../models/WPPageDescriptor";
import { configRefs } from "../constants/config";
import { DAYS_TO_MS, HOURS_TO_MS } from "../constants/time";
import { createCache } from "../createCache";

import type { ApiClientOptions } from "./typings/ApiClientOptions";
import type { ApiRequestInterceptor } from "./typings/ApiRequestInterceptor";
import { fetchRequest } from "./utils/fetchRequest";

export function makeFetchPage(
  requestInterceptor: ApiRequestInterceptor,
  options: ApiClientOptions,
) {
  const cache = createCache<Array<WPContentBlock | null>>({
    timeToLiveMs: 1 * HOURS_TO_MS,
    timeToEvictMs: 1 * DAYS_TO_MS,
    ...options,
  });

  return (user: User | undefined, pageDescriptor: WPPageDescriptor) => {
    const userType = user?.type ?? "guest";

    return cache(`${userType}:${pageDescriptor.id}`, async () => {
      const response = await fetchRequest<{
        contentItems: Array<WPContentBlock | null>;
      }>(
        requestInterceptor(
          `${await configRefs.apis.webproever.get()}${pageDescriptor.internalPath}?user-role=${userType}`,
        ),
      );

      return response.contentItems;
    });
  };
}
